import axios from 'axios';
import { API_BASE_URL } from '../utils/constants';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'accept': '*/*'
  },
  timeout: 30000
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Don't log cancelled requests - this is expected behavior when navigating
    if (error.code === 'ERR_CANCELED' || error.message === 'canceled') {
      console.log('Request cancelled (expected behavior)');
      return Promise.reject(error);
    }

    // Log actual errors
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

export default apiClient;
